import { /* useCallback,*/ useEffect, useState } from 'react';
import { /*Card,*/ Tabs } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { useResource } from 'app/common/api';
import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import { DataStore } from 'app/common/data-storage/features/data-storage';
import {
  NotificationsProvider,
  NotificationsRender,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { TPersonData } from 'app/railways/domains/passengers/core/person';
import { appRoute } from 'app/railways/router/routes';
import { Loading, PageContent, Stack } from 'app/ui';

import { CanAccess } from '../../access/features/permissions';
import { TTicketOrder } from '../core/tickets-order';
// import { CancelOrder } from '../features/cancel-order';
import { DetailsOrder } from '../features/details-ticket-order/details-order';
import { DetailsPerson } from '../features/details-ticket-order/details-person';
import { getTicketOrderRequest } from '../requests';

type OrderData = { person: TPersonData; order: TTicketOrder };

export const DetailsTicketOrderPage = observer(() => {
  const { id: orderId } = useTypedParams(appRoute.TICKETS.ORDER);

  const pageNotify = useNotifyFactory();

  const [dataStore] = useState(
    () =>
      new DataStore<OrderData>({
        person: {
          id: 0,
          phone: '',
        },
        order: {
          id: 0,
          personId: 0,
          date: '',
          status: 0,
          description: '',
          tripId: 0,
          stationFromId: 0,
          stationToId: 0,
          tickets: [],
          ticketQr: '',
          payType: 0,
          paySumm: 0,
          payReturnUrl: '',
          payConfirmationUrl: '',
          payConfirmationStatus: 0,
          payRemoteId: 0,
          payCheckDate: '',
        },
      }),
  );

  const getPersonResource = useResource<TTicketOrder['id'], OrderData>({
    request: getTicketOrderRequest,
    errorNotify: pageNotify,
    onDone: (orderData) => {
      dataStore.setData(orderData);
    },
  });

  useEffect(() => {
    if (!orderId) return;

    getPersonResource.send(orderId);
  }, [getPersonResource, orderId]);

  // const handleUpdateOrder = useCallback(
  //   (updatedOrder: TTicketOrder) => {
  //     dataStore.setData((oldData) => ({
  //       person: oldData.person,
  //       order: updatedOrder,
  //     }));
  //   },
  //   [dataStore],
  // );

  const order = dataStore.data.order;
  const person = dataStore.data.person;
  const loading = getPersonResource.isLoading;

  return (
    <NotificationsProvider value={pageNotify}>
      <AppPage perm="PERM_TICKET_ORDER_READ">
        <Tabs
          style={{ marginTop: 1 }}
          tabBarStyle={{ margin: 0, background: 'white', padding: '0 16px' }}
        >
          <Tabs.TabPane tab="Подробная информация" key="order">
            <PageContent>
              <Stack>
                <NotificationsRender notifyStore={pageNotify} />

                <Loading active={loading}>
                  <DetailsOrder order={order} />
                </Loading>
              </Stack>
            </PageContent>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Данные пассажира" key="person">
            <CanAccess perm="PERM_PERSON_READ">
              <PageContent>
                <Stack>
                  <NotificationsRender notifyStore={pageNotify} />

                  <Loading active={loading}>
                    <DetailsPerson person={person} />
                  </Loading>
                </Stack>
              </PageContent>
            </CanAccess>
          </Tabs.TabPane>

          {/* <Tabs.TabPane tab="Управление" key="actions">
            <PageContent>
              <Stack>

                <NotificationsRender notifyStore={pageNotify}>
                  {(notifications) => notifications}
                </NotificationsRender>

                <Card size="small" title="Отмена заказа">
                  <CancelOrder
                    order={order}
                    onOrderUpdate={handleUpdateOrder}
                  />
                </Card>
              </Stack>
            </PageContent>
          </Tabs.TabPane> */}
        </Tabs>
      </AppPage>
    </NotificationsProvider>
  );
});
